import { html, repeat, when } from '@microsoft/fast-element';
import { returnBackIcon } from '../../../../styles';
import { VppaRankings } from '../../../../types';
import { PRODUCT_TYPE } from '../../../../utils';
import type { AnalyticsStepThree } from './analytics-step-three';
import { AnalyticsSummaryTableColumn } from './summary-table-collumn/summary-table-column';

AnalyticsSummaryTableColumn;

export const AnalyticsStepThreeTemplate = html<AnalyticsStepThree>`
  <div class="container">
    <zero-card class="summary-card no-padding-card">
      <div class="horizontal summary-card-header" orientation="horizontal">
        <zero-button
          class="return-button"
          slot="start"
          appearance="secondary"
          @click=${(x) => (x.buyerAnalyticsService.currentStep = 2)}
        >
          ${returnBackIcon('start')}
        </zero-button>
        <span slot="start" class="tab-title">Summary</span>
      </div>
      <div class="summary-card-body">
        <div class="summary-table">
          <div
            class="summary-table-headers summary-table-columns ${(x) =>
              x.buyerAnalyticsService.currentPreferences.PRODUCT_TYPE === PRODUCT_TYPE.RECS ? 'columns-recs' : ''}"
          >
            <div></div>
            <div>Seller</div>
            <div>Project Name</div>
            <div>Technology Type</div>
            <div>Location</div>
            <div>Nameplate Capacity</div>
            <div>Buyer's Fraction</div>
            <div>ISO</div>
            ${when(
              (x) => x.buyerAnalyticsService.currentPreferences.PRODUCT_TYPE !== PRODUCT_TYPE.RECS,
              html`
                <div>Settlement Point</div>
                <div>Settlement Point Index</div>
              `
            )}
            <div>Tenor Start Date</div>
            <div>Tenor (months)</div>
            <div>Fixed Price</div>
            <div>Expected Settlement</div>
            <div>Nodal LME - Historical</div>
            <div>Implied Carbon Price</div>
            <div>Project Additionality</div>
            <div>Applicable REC Program</div>
            <div>Performance Guarantee Method</div>
            <div>VPPA Unique ID</div>
            <div>Form Agreement Type</div>
            <div>Contract Type</div>
            <div></div>
          </div>
          ${repeat(
            (x) => x.selectedVppaRankings,
            html<VppaRankings>`
              <summary-table-column
                class="summary-table-columns ${(x, c) =>
                  c.parent.buyerAnalyticsService.currentPreferences.PRODUCT_TYPE === PRODUCT_TYPE.RECS
                    ? 'columns-recs'
                    : ''}"
                :data=${(x) => x}
                :isFirst=${(x, c) => c.isFirst}
                :isLast=${(x, c) => c.isLast}
              ></summary-table-column>
            `,
            { positioning: true }
          )}
        </div>
      </div>
    </zero-card>
  </div>
`;
